import { useEffect } from 'react';
import { unstable_useBlocker as useBlocker } from 'react-router-dom';
import { BlockerRouterModal } from '../blocker-router-modal/blocker-router-modal';

/**
 * Блокирует навигацию внутри SPA, пока when === true, и показывает
 * подтверждающую модалку. Также перехватывает закрытие/перезагрузку вкладки
 * через нативный диалог браузера (beforeunload).
 * Работает только под data router (RouterProvider).
 */
export const NavigationBlocker = ({ when }) => {
	const blocker = useBlocker(when);

	useEffect(() => {
		if (!when) {
			return undefined;
		}

		const handleBeforeUnload = (event) => {
			event.preventDefault();
			event.returnValue = '';
		};

		window.addEventListener('beforeunload', handleBeforeUnload);
		return () => window.removeEventListener('beforeunload', handleBeforeUnload);
	}, [when]);

	if (blocker.state !== 'blocked') {
		return null;
	}

	return (
		<BlockerRouterModal
			isOpen
			close={() => blocker.reset()}
			modalParams={{
				onConfirm: () => blocker.proceed(),
				onCancel: () => blocker.reset(),
			}}
		/>
	);
};
